module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topics-areas"
    }
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._m(0), _vm._v(" "), (_vm.isLoading) ? _c('loading') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('ul', {
    staticClass: "grid grid-5-columns"
  }, _vm._l((_vm.topics), function(topic) {
    return _c('li', {
      key: topic.id
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'home',
          params: {
            type: 'tematica',
            slug: topic.slug
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.goToDataView($event)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": topic.image
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "img-caption"
    }, [_vm._v(_vm._s(topic.name))])])], 1)
  })) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('h3', [_vm._v("Temas")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e19696dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopicsAreas.vue
// module id = 61
// module chunks = 1